export default __webpack_public_path__ + "static/media/gato-marron_0.37f31d7b.jpg";